import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { CurrencyDenomination } from '@common/types';
import { ICommandBase } from '@Quest/cqrs';
import PnlViewer from '@Quest/Pnls/Components/PnlViewer.vue';
import { PnlTemplateReadModel } from '@Quest/Pnls/Domain/readmodels';
import ProjectNavigation from '@Quest/Projects/Components/ProjectNavigation.vue';
import { UpdateBenefitsConfidenceFactorCommandV1 } from '@Quest/Projects/Domain/commands-core';
import ProjectsCommands from '@Quest/Projects/Domain/commands-vue-component';
import ProjectsQueries from '@Quest/Projects/Domain/queries-vue-component';
import { ProjectPnlReadModel, RedirectionReadModel } from '@Quest/Projects/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioNavigation, ProjectNavigation, PnlViewer
    }
})
export default class PnlPage extends mixins(ProjectsQueries, ProjectsCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }
    get projectId() { return this.$route.params.projectId; }
    get portfolioId()
    {
        if (!this.rm?.PortfolioId)
        {
            throw new Error('PortfolioId is not defined.');
        }
        return this.rm.PortfolioId;
    }

    get isWorkspaceMember(): boolean | undefined { return this.rm?.IsWorkspaceMember ?? false }
    get isProjectOwner(): boolean | undefined { return this.rm?.IsProjectOwner ?? false }

    rm: ProjectPnlReadModel | null = null;
    pnlTemplates: PnlTemplateReadModel[] = [];

    cagrVisible: boolean = false;
    pnlId: string | null = null;
    applyBenefitsConfidenceFactor: boolean = false;
    benefitsConfidenceFactorInput: number | null = null;
    savingBenefitsConfidenceFactorInput: boolean = false;

    get selectedPnl(): PnlTemplateReadModel | null
    {
        if (this.pnlTemplates)
        {
            return (this.pnlId ? this.pnlTemplates.find(a => a.Id === this.pnlId) : this.pnlTemplates.find(a => a.IsDefault === true)) ?? null;
        }

        return null;
    }

    get benefitsConfidenceFactorLabel(): string
    {
        if (this.rm!.BenefitsConfidenceFactorValue != null)
        {
            return `${this.rm!.BenefitsConfidenceFactorValue.toString()}%`;
        }
        else
        {
            return "100%"
        }
    }

    reloadPnl()
    {
        if (!this.rm) return;
        this.runProjectPlanPnlQueryV1(this.workspaceId, this.tchProjectId, this.rm.ProjectId, this.rm.ProjectPlanId, this.pnlId, this.applyBenefitsConfidenceFactor, this.rm.Denomination);
        this.rm = null;
    }

    toggleBenefitsConfidenceFactor()
    {
        this.applyBenefitsConfidenceFactor = !this.applyBenefitsConfidenceFactor;
        this.reloadPnl();
    }

    toggleCagrVisible()
    {
        this.cagrVisible = !this.cagrVisible;
    }

    switchPnlTemplate(pnlId: string | null)
    {
        this.pnlId = pnlId;
        this.reloadPnl();
    }

    setDenomination(d: CurrencyDenomination)
    {
        this.rm.Denomination = d;
        this.reloadPnl();
    }

    handleUpdateBenefitsConfidenceFactorCommand()
    {
        if (!this.rm) return;
        this.savingBenefitsConfidenceFactorInput = true;
        this.invokeUpdateBenefitsConfidenceFactorCommandV1(this.workspaceId, this.portfolioId, this.projectId, this.rm.ActivePlanId, this.rm.ProjectPlanId, this.benefitsConfidenceFactorInput);
    }

    mounted()
    {
        document.title = "Project P&L | TransparentChoice";
        const projectPlanId = this.$route.params.planId;

        this.runProjectPlanPnlQueryV1(this.workspaceId, this.tchProjectId, this.projectId, projectPlanId, this.pnlId, this.applyBenefitsConfidenceFactor, null);

    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "RedirectionReadModel")
        {
            const rm = model as RedirectionReadModel;
            window.location.replace(rm.Url);
        }
        else if (modelName === "ProjectPnlReadModel")
        {
            this.rm = model as ProjectPnlReadModel;
            this.benefitsConfidenceFactorInput = this.rm.BenefitsConfidenceFactorValue;
            this.pnlTemplates = this.rm.PnlTemplates;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateBenefitsConfidenceFactorCommandV1.matchType(cmd))
        {
            this.reloadPnl();
            this.savingBenefitsConfidenceFactorInput = false;
        }
    }
}